import React from "react";
import usePortalSearchItems from "../common/usePortalSearchItems";
import PortalPCSidebarKeywordForm from "./PortalPCSidebarKeywordForm";
import PortalPCCollapsibleSection from "./PortalPCCollapsibleSection";
import PortalPCCheckboxList from "./PortalPCCheckboxList";
import PortalPCAreaCheckboxList from "./PortalPCAreaCheckboxList";
import PortalPCRangeField from "./PortalPCRangeField";
import PortalPCPriceField from "./PortalPCPriceField";

function PortalPCSearchSidebar() {
  const {
    kindItem,
    genreItem,
    positionItem,
    characteristicItem,
    atmosphereItem,
    skillItem,
    termItem,
    priceItem,
  } = usePortalSearchItems();

  return (
    <aside className="portalPcSidebar">
      <h2 className="portalPcSidebarHeading">募集を絞り込む</h2>

      <PortalPCSidebarKeywordForm />

      <PortalPCCollapsibleSection title="活動場所" collapsible={false}>
        <PortalPCAreaCheckboxList idPrefix="portal-pc-sidebar" />
      </PortalPCCollapsibleSection>
      {kindItem && (
        <PortalPCCollapsibleSection title={kindItem.title} collapsible={false}>
          <PortalPCCheckboxList idPrefix="portal-pc-sidebar" item={kindItem} />
        </PortalPCCollapsibleSection>
      )}
      {positionItem && (
        <PortalPCCollapsibleSection
          title={positionItem.title}
          collapsible={false}
        >
          <PortalPCCheckboxList
            idPrefix="portal-pc-sidebar"
            item={positionItem}
          />
        </PortalPCCollapsibleSection>
      )}
      {genreItem && (
        <PortalPCCollapsibleSection title={genreItem.title} collapsible={false}>
          <PortalPCCheckboxList idPrefix="portal-pc-sidebar" item={genreItem} />
        </PortalPCCollapsibleSection>
      )}
      {characteristicItem && (
        <PortalPCCollapsibleSection title={characteristicItem.title}>
          <PortalPCCheckboxList
            idPrefix="portal-pc-sidebar"
            item={characteristicItem}
          />
        </PortalPCCollapsibleSection>
      )}
      {atmosphereItem && (
        <PortalPCCollapsibleSection title={atmosphereItem.title}>
          <PortalPCCheckboxList
            idPrefix="portal-pc-sidebar"
            item={atmosphereItem}
          />
        </PortalPCCollapsibleSection>
      )}
      {skillItem && (
        <PortalPCCollapsibleSection title={skillItem.title}>
          <PortalPCCheckboxList idPrefix="portal-pc-sidebar" item={skillItem} />
        </PortalPCCollapsibleSection>
      )}
      {termItem && (
        <PortalPCCollapsibleSection title="期間">
          <PortalPCRangeField item={termItem} />
        </PortalPCCollapsibleSection>
      )}
      {priceItem && (
        <PortalPCCollapsibleSection title="費用">
          <PortalPCPriceField item={priceItem} />
        </PortalPCCollapsibleSection>
      )}
    </aside>
  );
}

export default PortalPCSearchSidebar;
